import { createContext, useContext, ReactNode } from "react";
import { useBackgroundSync } from "@/hooks/useBackgroundSync";

interface BackgroundSyncContextType {
  registerSync: (name: string, sync: () => Promise<void>) => void;
  unregisterSync: (name: string) => void;
  syncNow: () => Promise<void>;
}

const BackgroundSyncContext = createContext<BackgroundSyncContextType | null>(null);

export function BackgroundSyncProvider({ children }: { children: ReactNode }) {
  const sync = useBackgroundSync();

  return (
    <BackgroundSyncContext.Provider value={sync}>
      {children}
    </BackgroundSyncContext.Provider>
  );
}

export function useBackgroundSyncContext() {
  const context = useContext(BackgroundSyncContext);
  if (!context) {
    throw new Error("useBackgroundSyncContext must be used within BackgroundSyncProvider");
  }
  return context;
}
